import { useQuery, gql } from '@apollo/react-hooks';
import { getWorkOrderTemplateList } from '#/graphql/queries';
import type {
  GetWorkOrderTemplateListQuery,
  GetWorkOrderTemplateListQueryVariables,
} from '#/graphql/types';

const q = gql(getWorkOrderTemplateList);

const useWOTemplateListQuery = (variables?: GetWorkOrderTemplateListQueryVariables) => {
  const result = useQuery<GetWorkOrderTemplateListQuery, GetWorkOrderTemplateListQueryVariables>(
    q,
    { variables },
  );

  return result;
};

export default useWOTemplateListQuery;
